<template>
  <div class="kpi-achieve-detail-page">
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" color="#3283fa" :sticky="true" :swipe-threshold="2" @change="setType">
      <van-tab v-for="(title) in types" :key="title.title" :title="title.title">
        <van-list v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —" @load="getMoreList">

          <!--品牌负责人-->
          <div class="content" v-if="userType == 'brand' && typeIndex == 1">
            <ul class="select-ul">
              <li class="select-title">
                <div class="bottom-line">
                  <van-cell :title="brand_store_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getStoreList"/>
                </div>
                <van-popup v-model="show_store" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_store" class="overy_auto">
                    <van-cell title="所有门店" clickable @click="brandClose('所有门店', 0)" class="bottom-line">
                      <van-radio name="所有门店" />
                    </van-cell>
                    <template v-if="stores&&stores.length > 0">
                      <van-cell-group v-for="(item,key) in stores" :key="key">
                        <van-cell :title="item.name" clickable @click="brandClose(item, 1)" class="bottom-line">
                          <van-radio :name="item.name" />
                        </van-cell>
                      </van-cell-group>
                    </template>
                  </van-radio-group>
                </van-popup>
              </li>
              <li class="select-title">
                <div class="bottom-line">
                  <van-cell :title="brand_staff_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getStaffList"/>
                </div>
                <van-popup v-model="show_staff" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_staff" class="overy_auto" v-if="staffs.length > 0">
                    <van-cell-group v-for="(item,key) in staffs" :key="key">
                      <van-cell :title="item.name" clickable @click="brandClose(item, 2)" class="bottom-line">
                        <van-radio :name="item.name" />
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </van-popup>
              </li>
            </ul>
          </div>

          <!--活动负责人-->
          <div class="content" v-if="userType == 'act' && typeIndex == 1">
            <ul class="select-ul bottom-line">
              <li class="select-title">
                <van-cell :title="ward_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getWardList"/>
                <van-popup v-model="show_ward" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_ward" class="overy_auto" v-if="wards.length > 0">
                    <van-cell-group v-for="(item,key) in wards" :key="key">
                      <van-cell :title="item.name" clickable @click="close(item, 5)" class="bottom-line">
                        <van-radio :name="item.name" />
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </van-popup>
              </li>
              <li class="select-title">
                <van-cell :title="legion_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getLegionList"/>
                <van-popup v-model="show_legion" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_legion" class="overy_auto" v-if="legions.length > 0">
                    <van-cell-group v-for="(item,key) in legions" :key="key">
                      <van-cell :title="item.name" clickable @click="close(item, 1)" class="bottom-line">
                        <van-radio :name="item.name" />
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </van-popup>
              </li>
              <li class="select-title">
                <van-cell :title="brand_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getBrandList"/>
                <van-popup v-model="show_brand" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_brand" class="overy_auto" v-if="brands.length > 0">
                    <van-cell-group v-for="(item,key) in brands" :key="key">
                      <van-cell :title="item.name" clickable @click="close(item, 2)" class="bottom-line">
                        <van-radio :name="item.name" />
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </van-popup>
              </li>
              <li class="select-title">
                <van-cell :title="store_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getStoreList"/>
                <van-popup v-model="show_store" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_store" class="overy_auto">
                    <van-cell title="所有门店" clickable @click="close('所有门店', 0)" class="bottom-line">
                      <van-radio name="所有门店" />
                    </van-cell>
                    <template v-if="stores&&stores.length > 0">
                      <van-cell-group v-for="(item,key) in stores" :key="key" >
                        <van-cell :title="item.name" clickable @click="close(item, 3)" class="bottom-line">
                          <van-radio :name="item.name" />
                        </van-cell>
                      </van-cell-group>
                    </template>
                  </van-radio-group>
                </van-popup>
              </li>
              <li class="select-title">
                <van-cell :title="staff_title" title-class="one-nowrap" is-link arrow-direction="down" @click="getStaffList"/>
                <van-popup v-model="show_staff" overlay-class="achieve-overlay">
                  <van-radio-group v-model="radio_staff" class="overy_auto" v-if="staffs.length > 0">
                    <van-cell-group v-for="(item,key) in staffs" :key="key">
                      <van-cell :title="item.name" clickable @click="close(item, 4)" class="bottom-line">
                        <van-radio :name="item.name" />
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </van-popup>
              </li>
            </ul>
          </div>
          <div class="order">
            <div class="item bottom-line" v-for="(item,index) of list" :key="index">
              <h4 v-if="(rankType=='live_self_order'||rankType=='live_other_order'||rankType=='live_self_order_change'||rankType=='live_other_order_change')&&item.name">{{item.name}}</h4>
              <h4 v-if="(rankType=='process_self_order'||rankType=='process_devote_order')&&item.name">{{item.name}}</h4>
              <h4 v-if="rankType=='seckill_user'&&item.name">{{item.name}}</h4>
              <p v-if="rankType=='live_self_order'||rankType=='live_other_order'||rankType=='live_self_order_change'||rankType=='live_other_order_change'">商品所属品牌：{{item.itemBrandName||'无'}}</p>
              <p v-if="rankType=='process_self_order'||rankType=='process_devote_order'">优惠券所属品牌：{{item.itemBrandName||'无'}}</p>
              <p v-if="rankType=='seckill_user'">秒杀商品所属品牌：{{item.itemBrandName||'无'}}</p>
              <p v-if="rankType!='process_self_order'&&rankType=='process_devote_order'">订单ID：{{item.tradeNo}}</p>
              <p v-if="rankType!='process_self_order'&&rankType=='process_devote_order'">订单金额：{{item.payAmount}}元</p>
              <p>客户姓名：{{item.userName||'无'}}</p>
              <p>客户手机号：{{item.mobile||'无'}}</p>
              <p>导购员：{{item.blUserName||'无'}}</p>
              <p>所属品牌：{{item.blBrandName||'无'}}</p>
              <p>所属门店：{{item.blShopName||'无'}}</p>
              <p v-if="rankType!='seckill_user'">转单金额：{{item.changeAmount}}元</p>
              <p v-if="rankType=='live_self_order'||rankType=='live_other_order'">下单时间： {{item.createTime||'无'}}</p>
              <p v-if="rankType!='live_self_order'&&rankType!='live_other_order'">核销时间： {{item.finishTime||'无'}}</p>
              <p v-if="rankType!='seckill_user'">奖励金额：{{item.bonusAmount}}元</p>
            </div>
          </div>
        </van-list>

      </van-tab>
    </van-tabs>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
// import appFooter from '../../components/kpi-footer/index.vue';
import backHome from '../../components/back-home.vue';

export default {
  components: {
    // appFooter,
    backHome
  },
  data() {
    return {
      load: true,//默认一开始不执行@load的方法
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      userType: localStorage.getItem("userType"),
      title: this.$route.query.title,
      rankType: this.$route.query.type,//业绩类型
      typeIndex: 0,
      types: [
        { title: '我的客户' },
        { title: '全部客户' }
      ],
      params: {
        index: 1,
        size: 50,
        loading: false,
        finished: false,
      },
      list: [],
      wards: [], //战区列表
      legions: [], // 军团列表
      brands: [], // 品牌列表
      stores: [], // 门店列表
      staffs: [], // 导购员列表
      ward_title: '战区',
      legion_title: '军团',
      brand_title: '品牌',
      store_title: '门店',
      staff_title: '导购员',
      brand_store_title: '门店选择',
      brand_staff_title: '导购员选择',
      radio_ward: null,
      radio_legion: null,
      radio_brand: null,
      radio_store: null,
      radio_staff: null,
      ward_id: null,
      legion_id: null,
      brand_id: null,
      store_id: null,
      staff_id: null,
      kpi_user_id: null,
      show_ward: false,
      show_legion: false,
      show_brand: false,
      show_store: false,
      show_staff: false,
      allItem: {name: '全部', id: null},
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = this.title;
    this.getList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    setType(index) {
      this.params.loading = false;
      this.params.finished = false;
      this.list = [];
      this.params.index = 1;
      if (index === 1) {
        this.ward_id = null;
        this.legion_id = null;
        this.brand_id = this.userType=='act'?null:(localStorage.getItem('brand_id') || null);
        this.store_id = null;
        this.staff_id = null;
        this.ward_title = '战区';
        this.legion_title = '军团';
        this.brand_title = '品牌';
        this.store_title = '门店';
        this.staff_title = '导购员';
        this.brand_store_title = '门店选择';
        this.brand_staff_title = '导购员选择';
        this.wards = [];
        this.legions = [];
        this.brands = [];
        this.stores = [];
        this.staffs = [];
        this.radio_ward = null;
        this.radio_legion = null;
        this.radio_brand = null;
        this.radio_store = null;
        this.radio_staff = null;
      }
      this.getList();
    },
    // 获取战区列表
    getWardList(){
      this.show_legion = false;
      this.show_brand = false;
      this.show_store = false;
      this.show_staff = false;
      if (!this.show_ward) {
        this.$kpi.rank.getGeneralList({
          "actId": Number(this.activity_id),
          "page": -1,
          "size": -1
        }).then((res) => {
          console.log(res)
          if(res.code==0){
            var data=res.data;
            this.wards = data.list;
            if (data.list.length < 1) {
              this.wards = [this.allItem]
              // this.$toast("暂无更多战区");
            }else{
              this.wards.push(this.allItem)
            }
            this.show_ward = true;
          }else if(res.code==10200){
            this.$toast("暂无更多战区");
          }
        });
      } else {
        this.show_ward = false;
      }
    },
    // 获取军团列表
    getLegionList(){
      this.show_ward = false;
      this.show_brand = false;
      this.show_store = false;
      this.show_staff = false;
      if (!this.show_legion) {
        this.$kpi.achieve.getLegionList({
          "actId": Number(this.activity_id),
          "generalId": this.ward_id || null,
          "page": -1,
          "size": -1
        }).then((res) => {
          console.log(res)
          if(res.code==0){
            var data=res.data;
            this.legions = data.list;
            if (data.list.length < 1) {
              this.legions = [this.allItem]
              // this.$toast("暂无更多军团");
            }else{
              this.legions.push(this.allItem)
            }
            this.show_legion = true;
          }else if(res.code==10200){
            this.$toast("暂无更多军团");
          }
        });
      } else {
        this.show_legion = false;
      }
    },
    // 下拉框--获取品牌列表
    getBrandList() {
      this.show_ward = false;
      this.show_legion = false;
      this.show_store = false;
      this.show_staff = false;
      if (!this.show_brand) {
        this.$kpi.achieve.getRrandList({
          "actId": Number(this.activity_id),
          "generalId": this.ward_id || null,
          "catId": this.legion_id,
          "page": -1,
          "size": -1
        }).then((res) => {
          console.log(res)
          if(res.code==0){
            var data=res.data;
            this.brands = data.list;
            if (data.list.length < 1) {
              this.brands = [this.allItem]
              // this.$toast("暂无更多品牌");
            }else{
              this.brands.push(this.allItem)
            }
            this.show_brand = true;
          }else if(res.code==10200){
            this.$toast("暂无更多品牌");
          }
        });
      } else {
        this.show_brand = false;
      }
    },
    // 门店列表
    getStoreList() {
      if(!this.brand_id && this.userType=='act' && this.radio_brand !== '全部'){
        return this.$toast("请先选择品牌");
      }
      this.show_ward = false;
      this.show_legion = false;
      this.show_brand = false;
      this.show_staff = false;
      if (!this.show_store) {
        this.$kpi.achieve.getStoreList({
          "actId": Number(this.activity_id),
          "generalId": this.ward_id || null,
          "catId": this.legion_id,
          "brandId": this.brand_id,
          "page": -1,
          "size": -1
        }).then((res) => {
          console.log(res)
          if(res.code==0){
            this.stores = res.data.list;
            this.show_store = true;
          }else if(res.code==10200){
            this.stores = [];
            this.show_store = true;
          }
        });
      } else {
        this.show_store = false;
      }
    },
    // 获取导购员
    getStaffList() {
      if (this.radio_store !== '所有门店' && !this.store_id) {
        return this.$toast('请先选择门店');
      }
      this.show_ward = false;
      this.show_legion = false;
      this.show_brand = false;
      this.show_store = false;
      if (!this.show_staff) {
        this.$kpi.achieve.getStaffList({
          "actId": Number(this.activity_id),
          "generalId": this.ward_id || null,
          "brandId": this.brand_id || null,
          "catId": this.legion_id || null,
          "shopId": this.store_id || null,
          "type": '',
          "recharged": 1,
          "page": -1,
          "size": -1
        }).then((res) => {
          console.log(res)
          if(res.code==0){
            var data=res.data;
            this.staffs = data.list;
            if (data.list.length < 1) {
              this.staffs = [this.allItem]
              // this.$toast("暂无更多导购员");
            }else{
              this.staffs.push(this.allItem)
            }
            this.show_staff = true;
          }else if(res.code==10200){
            this.$toast("暂无更多导购员");
          }
        });
      } else {
        this.show_staff = false;
      }
    },
    // 选中--关闭下拉框
    close(item, index) {
      if (index === 0||index === 3) {
        this.radio_store = index?item.name:item;
        this.store_title = index?item.name:item;
        this.store_id = index?item.id:0;
        this.staffs = [];
        this.show_store = false;
        this.staff_title = '导购员';
        this.radio_staff = null;
        this.staff_id = null;
      } else if (index === 1) {
        this.radio_legion = item.name;
        this.legion_title = item.name;
        this.legion_id = item.id;
        this.brands = [];
        this.stores = [];
        this.staffs = [];
        this.show_legion = false;
        this.brand_title = '品牌';
        this.store_title = '门店';
        this.staff_title = '导购员';
        this.radio_brand = null;
        this.radio_store = null;
        this.radio_staff = null;
        this.brand_id = null;
        this.store_id = null;
        this.staff_id = null;
      } else if (index === 2) {
        this.radio_brand = item.name;
        this.brand_title = item.name;
        this.brand_id = item.id;
        this.stores = [];
        this.staffs = [];
        this.show_brand = false;
        this.store_title = '门店';
        this.staff_title = '导购员';
        this.radio_store = null;
        this.radio_staff = null;
        this.store_id = null;
        this.staff_id = null;
      } else if (index === 4) {
        this.radio_staff = item.name;
        this.staff_title = item.name;
        this.staff_id = item.id;
        this.show_staff = false;
      } else if (index === 5) {
        this.radio_ward = item.name;
        this.ward_title = item.name;
        this.ward_id = item.id;
        this.legion_title = '军团'
        this.brand_title = '品牌';
        this.store_title = '门店';
        this.staff_title = '导购员';
        this.brands = [];
        this.stores = [];
        this.staffs = [];
        this.legions = [];
        this.radio_legion = null;
        this.radio_brand = null;
        this.radio_store = null;
        this.radio_staff = null;
        this.legion_id = null;
        this.brand_id = null;
        this.store_id = null;
        this.staff_id = null;
        this.show_ward = false;
      }
      // 客户列表清零
      this.params.loading = false;
      this.params.finished = false;
      this.params.index = 1;
      this.list = [];
      this.getList();
    },
    brandClose(item, index) {
      if (index === 0||index === 1) {
        this.radio_store = index?item.name:item;
        this.brand_store_title = index?item.name:item;
        this.store_id = index?item.id:0;
        this.staffs = [];
        this.show_store = false;
        this.staff_title = '导购员';
        this.radio_staff = null;
        this.staff_id = null;
      } else if (index === 2) {
        this.radio_staff = item.name;
        this.brand_staff_title = item.name;
        this.staff_id = item.id;
        this.show_staff = false;
      }
      // 客户列表清零
      this.params.loading = false;
      this.params.finished = false;
      this.params.index = 1;
      this.list = [];
      this.getList();
    },
    // 获取客户列表
    getList() {
      this.params.loading = true;
      this.$kpi.achieve.getMyOrderList({
        "actId": Number(this.activity_id),
        "catId": this.legion_id || null,
        "brandId": this.brand_id || null,
        "shopId": this.store_id || null,
        "kpiUserId": !this.typeIndex ? this.kpi_userid : (this.staff_id||null),
        "page": this.params.index || 1,
        "size": this.params.size || 50,
        "type": this.rankType,
        "generalId": this.ward_id || null,
      }).then(res=>{
        console.log(res)
        this.params.loading = false;
        this.load = false;
        if(res.code==0){
          var data=res.data;
          this.list = this.list.concat(data.list) || [];
          if(!data.list.length||data.list.length<this.params.size){
            this.params.finished = true;
          }
        }else if(res.code==10200){
          this.params.finished=true;
        }
      });
    },
    getMoreList(){
      console.log(this.params.finished,this.load)
      if(this.params.finished||this.load) return;
      ++this.params.index;
      this.getList();
    }
  }
};

</script>

<style lang="less" scoped>
.kpi-achieve-detail-page {
  height: 100vh;
  .order{
    .item{
      display: flex;
      flex-direction: column;
      padding: 8px 15px;
      background: #fff;
      h4{
        font-size: 14px;
        margin: 10px 0;
      }
      p{
        line-height: 1.5;
      }
    }
  }
  .content {/*下拉框*/
    position: sticky;
    top: 44px;
    z-index: 1;
    .select-ul {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 44px;
      .select-title {
        flex: 1;
        .van-cell{
          padding: 10px 5px;
          text-align: center;
          font-size: 12px;
          /deep/ .van-cell__right-icon {
            margin-left: 0;
            font-size: 12px;
          }
        }
        /deep/.overy_auto {/*radio可滑动*/
          overflow-y: auto;
          max-height: calc(100vh - 100px);
        }
        /deep/.overy_auto::-webkit-scrollbar {display:none}
        .van-popup {
          top: 85px;
          left: 0;
          transform: translate(0);
          width: 100%;
        }
        /deep/.achieve-overlay {/*业绩详情-蒙层*/
          top: 85px;
        }
        .van-cell:not(:last-child)::after {
          content: ' ';
          border: none;
        }
        [class*=van-hairline]::after {
          content: ' ';
          border: none;
        }
        .van-cell__value{
          flex: none;
        }
      }
      .no-line::after {
        border: none;
      }
    }
  }
}

</style>
